import { UtilityBar } from "@/components/organisms/UtilityBar";

export function OrganizationsSubnav() {
  return (
    <>
      <UtilityBar />
    </>
  );
}
